/**
 * Approval-type affordances that platform_admin must not be offered (PRD s2.2: admin owns masters,
 * workflows and AI configs; approvals belong to the Lead Advisor and the Company SPOC). The API answers
 * a platform_admin caller 403 PLATFORM_ADMIN_APPROVAL_DENIED on each of these. UX convenience only - the
 * API is the enforcement (Commandments IV, V). Dependency-free so it is unit-testable.
 */
import { Role } from '../constants/roles';

/** Risk register approve (A.5.7-adjacent Stage 6 sign-off): Lead Advisor only. */
export const canApproveRiskRegister = (role) => role === Role.LEAD_ADVISOR;

/** Internal audit (Stage 9): circulate plan, close a corrective action, record management approval. */
export const canSignOffInternalAudit = (role) => role === Role.LEAD_ADVISOR;

/** AI dashboard tile approve (ISO/IEC 42001 A.9.2 human oversight): Lead Advisor only. */
export const canApproveDashboardTile = (role) => role === Role.LEAD_ADVISOR;
